import { Form, InputNumber } from 'antd';

import styles from './ConstantValueInput.module.scss';

type ConstantValueInputProps = {
  name: (string | number)[];
  label?: string;
  suffix?: string;
  isRequired?: boolean;
  inputRef?: React.Ref<HTMLInputElement>;
  placeholder?: string;
};

const RULES = [{ required: true, message: 'Required' }];

export const ConstantValueInput = ({
  name,
  label,
  suffix,
  isRequired = true,
  inputRef,
  placeholder,
}: ConstantValueInputProps) => {
  return (
    <div className={styles.inlineRow}>
      {label && <span>{label}</span>}

      <Form.Item
        name={name}
        rules={isRequired ? RULES : []}
        className={styles.inlineFormItem}
      >
        <InputNumber min={0} ref={inputRef} placeholder={placeholder} />
      </Form.Item>

      {suffix && <span>{suffix}</span>}
    </div>
  );
};
